export default {
  popup_title: 'Connect Your @:general.terminology.amazon_seller_account',
  popup_description:
    'Connect your <span class="connect-account__amz-text">@:general.terminology.amazon_seller_account</span> in just 4 steps!',
  authorize_hint:
    'Click the button below to login your @:general.terminology.amazon_seller_central and Authorize Eva',
  go_to_seller_central: 'Go to @:general.terminology.seller_central',
  select_store_hint:
    'Select the stores you want to connect to EVA. Click to connect button below to proceed.',
  successfully_connected:
    'You have successfully connected following Marketplaces.',
  marketplaces_couldnt_connect:
    'The following marketplaces could not be connected.',
};
